module.exports = __webpack_public_path__ + "img/risks-alcohol-dependence.e2efa88d.svg";